import { Check, CircleDashed, Clock3, UserRound, X } from "lucide-react";

export type ProcurementFlowStep = {
  role: string;
  label: string;
  status: "Onaylandı" | "Reddedildi" | "Bekliyor" | "Sırada";
  actor?: string;
  decidedAt?: string;
};

export type ProcurementFlowPresentation = {
  eyebrow: string;
  title: string;
  description?: string;
  owner?: string;
  ownerLabel?: string;
  ownerNote?: string;
};

export function ProcurementFlow({
  stage,
  steps,
  focusRole,
  compact = false,
  presentation,
}: {
  stage: string;
  steps: ProcurementFlowStep[];
  focusRole?: string;
  compact?: boolean;
  presentation?: ProcurementFlowPresentation;
}) {
  const isCompleted = stage === "Tamamlandı" || stage === "Onaylandı";
  const visibleStep =
    steps.find((step) => step.role === focusRole) ??
    steps.find((step) => step.status === "Bekliyor") ??
    [...steps].reverse()[0];

  return (
    <div
      className={`procurement-flow${compact ? " is-compact" : ""}${isCompleted ? " is-completed" : ""}`}
    >
      <div className="procurement-flow-current">
        <div className="procurement-flow-stage">
          <span className="procurement-flow-stage-icon" aria-hidden="true">
            {isCompleted ? (
              <Check />
            ) : stage === "Reddedildi" ? (
              <X />
            ) : (
              <Clock3 />
            )}
          </span>
          <div>
            <small>
              {presentation?.eyebrow ?? (isCompleted ? "Sonuç" : "Mevcut aşama")}
            </small>
            <strong>
              {presentation?.title ??
                (isCompleted ? "Satın alma tamamlandı" : stage)}
            </strong>
            {presentation?.description ? (
              <span className="procurement-flow-stage-description">
                {presentation.description}
              </span>
            ) : null}
          </div>
        </div>
        {presentation?.owner ? (
          <div
            className="procurement-flow-decision is-context"
            aria-label={`${presentation.ownerLabel ?? "Sorumlu"}: ${presentation.owner}`}
          >
            <i aria-hidden="true">
              <UserRound />
            </i>
            <div>
              <small>{presentation.ownerLabel ?? "Sorumlu"}</small>
              <strong>{presentation.owner}</strong>
              {presentation.ownerNote ? (
                <span>{presentation.ownerNote}</span>
              ) : null}
            </div>
          </div>
        ) : visibleStep && !presentation ? (
          <div
            className={`procurement-flow-decision is-${visibleStep.status.toLocaleLowerCase("tr")}`}
            aria-label={`${visibleStep.label}: ${visibleStep.status}`}
          >
            <i aria-hidden="true">
              {visibleStep.status === "Onaylandı" ? (
                <Check />
              ) : visibleStep.status === "Reddedildi" ? (
                <X />
              ) : visibleStep.status === "Bekliyor" ? (
                <Clock3 />
              ) : (
                <CircleDashed />
              )}
            </i>
            <div>
              <small>{visibleStep.label}</small>
              <strong>{visibleStep.status}</strong>
              {visibleStep.actor ? <span>{visibleStep.actor}</span> : null}
              {visibleStep.decidedAt ? (
                <time>
                  {new Date(visibleStep.decidedAt).toLocaleDateString("tr-TR")}
                </time>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
